module.exports = __webpack_public_path__ + "79b9e7c0c65e673b34b0e24c889f39a9.MP3";